// ISO local timestamps are produced by bookingDateTime before grouping.
export function groupBookingRanges(slots) {
  const ordered = slots.map((slot) => ({ ...slot })).sort((a, b) =>
    a.courtId.localeCompare(b.courtId) || a.startTime.localeCompare(b.startTime));
  const ranges = [];
  for (const slot of ordered) {
    const previous = ranges[ranges.length - 1];
    if (previous && previous.courtId === slot.courtId && previous.endTime === slot.startTime) previous.endTime = slot.endTime;
    else ranges.push(slot);
  }
  return ranges;
}
